var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apollo-view"},[_c('ContentView',{attrs:{"title":"Apollo GraphQL"}},[_vm._v(" Apollo Engine ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }